<span class="PGCopyClipboard">
    <span ngbDropdown>
        <span ngbDropdownToggle #copyClipboardTooltip="ngbTooltip" ngbTooltip="{{ 'pg-copy-clipboard.copied' | locTranslate }}" triggers="manual" (click)="copyClipboardText(text)">
            <ng-content></ng-content>
        </span>
        @if (options != null) {
            <div ngbDropdownMenu class="dropdown-menu PGCopyClipboard-Dropdown">
                @for (item of options; track item) {
                    <div class="dropdown-item" (click)="copyClipboardText(item.value)">
                        <div [innerHTML]="item.text"></div>
                        @if(item.tooltip) {
                            <div class="small text-muted" [innerHTML]="item.tooltip"></div>
                        }
                    </div>
                }
            </div>
        }
    </span>
</span>